module.exports = __webpack_public_path__ + "static/media/logo-dark-fr.1c4fa685.svg";